module.exports = __webpack_public_path__ + "img/growingannanas.770c4446.jpg";